import cn from 'classnames';

const CurrencyIcon = ({ ccy, className, disabled }: { ccy: string; className?: string; disabled?: boolean }) => {
    return (
        <img
            className={cn(
                'block rounded-full overflow-clip',
                { ['opacity-80']: disabled, 'h-6': !className },
                className
            )}
            src={`/currency_icons/svg/color/${ccy.toLowerCase()}.svg`}
            alt={ccy}
        />
    );
};

export default CurrencyIcon;
{
    /* <div className="block h-6 min-w-[1.5rem] rounded-full bg-neutral-300" /> */
}
